import React from "react";
import ChatPage from "./chunks/ChatPage";
import { currentUserStorage, serviceFactory } from "./services/chat";
import { AutoDraft, ChatProvider } from "./useChat";
const ChatContainer = () => {
    return /*#__PURE__*/ React.createElement(ChatProvider, {
        serviceFactory: serviceFactory,
        storage: currentUserStorage,
        config: {
            typingThrottleTime: 250,
            typingDebounceTime: 900,
            debounceTyping: true,
            autoDraft: AutoDraft.Save | AutoDraft.Restore
        }
    }, /*#__PURE__*/ React.createElement(ChatPage, null));
};
export default ChatContainer;
